import React from 'react'
import { Spin } from 'antd'
const loader = () => {
    return (
        <div className="loader">
            <Spin  size="large"/>
        </div>
    )
}

export default loader
